<template>
  <div class="o-logo">
    <img src="../assets/logo.gif" alt="Tiger Fortune Teller" />
  </div>
</template>

<script>
export default {
  name: "Logo"
}
</script>